import * as React from 'react';
import * as Sentry from '@sentry/browser';
import { useState, useEffect } from 'react';
import { myAreaStatsWatchedVideos } from '../../../../Utilities/api';
import Spinner from '../../Spinner';
import { useI18n } from '../../../../Translation';
import ProfileStatsInfoToolTip from './ProfileStatsInfoToolTip';
const ProfileStatsTileWatchedVideos = ({ label }) => {
    const i18n = useI18n();
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await myAreaStatsWatchedVideos();
                setData(result);
            }
            catch (error) {
                Sentry.captureException(error);
                setHasError(true);
            }
            finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);
    return <div className="relative overflow-hidden rounded-lg bg-white px-4 py-5 shadow-lg sm:p-6">
        <ProfileStatsInfoToolTip content={'Videos, die zu mehr als 90% angesehen wurden'}/>

        <div className="overflow-hidden">
            <dt className="truncate text-sm font-medium text-gray-500">{label}</dt>
            {isLoading ? (<Spinner />) : (<>
                    {hasError ? (<i className="mt-1">{i18n['profile.healthScore.errorWhileLoading']}</i>) : data ? (<dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">{data.count_finished}</dd>) : (<></>)}
                </>)}
        </div>
    </div>;
};
ProfileStatsTileWatchedVideos.displayName = 'ProfileStatsTileWatchedVideos';
export default ProfileStatsTileWatchedVideos;
